'use strict';

module.exports = exports = function (obj, path, defaultValue, delimiter) {
  if (typeof path === 'string') {
    path = path.split(delimiter || '.');
  }
  if (Array.isArray(path)) {
    var len = path.length;
    for (var i = 0; i < len; i++) {
      if (
        obj &&
        (Object.prototype.hasOwnProperty.call(obj, path[i]) || obj[path[i]])
      ) {
        obj = obj[path[i]];
      } else {
        return defaultValue;
      }
    }
    return obj;
  } else {
    return defaultValue;
  }
};



//////////////////
// WEBPACK FOOTER
// /Users/jeff/Projects/git/react-github-corner/node_modules/object-path-get/index.js
// module id = 353
// module chunks = 0